module.exports = __webpack_public_path__ + "img/p126.267ed874.jpg";